module.exports = __webpack_public_path__ + "img/banner_xxyw.7d4a353d.png";